type FiuuPaymentFormField = {
	name: string;
	value: string;
};

export const buildFiuuPaymentRedirectUrl = (
	actionUrl: string,
	fields: FiuuPaymentFormField[],
): string => {
	const baseUrl = actionUrl.endsWith('/') ? actionUrl : `${actionUrl}/`;
	const query = fields
		.map(
			({ name, value }) =>
				`${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
		)
		.join('&');

	return `${baseUrl}?${query}`;
};

/** Redirect via GET — matches Fiuu official PHP integration samples. */
export const redirectToFiuuPayment = (
	actionUrl: string,
	fields: FiuuPaymentFormField[],
	redirectUrl?: string | null,
) => {
	const targetUrl = redirectUrl || buildFiuuPaymentRedirectUrl(actionUrl, fields);
	window.location.assign(targetUrl);
};

/** POST fallback if GET redirect is blocked. */
export const submitFiuuPaymentForm = (
	actionUrl: string,
	fields: FiuuPaymentFormField[],
) => {
	const form = document.createElement('form');
	form.method = 'POST';
	form.action = actionUrl;
	form.acceptCharset = 'UTF-8';
	form.style.display = 'none';

	fields.forEach(({ name, value }) => {
		const input = document.createElement('input');
		input.type = 'hidden';
		input.name = name;
		input.value = value;
		form.appendChild(input);
	});

	document.body.appendChild(form);
	form.submit();
};
